<router-outlet></router-outlet>
<div hidden>
  build date: {{ buildInfo.timestamp }}<br />
  src: {{ buildInfo.git.branch }}/{{ buildInfo.git.fullHash }}
</div>
